module.exports = __webpack_public_path__ + "static/media/20.9a33bec8.jpg";